"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FPCTPageOne;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _FinancialPlanningCheckupFormControls = require("./FinancialPlanningCheckupFormControls");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable no-unused-vars */

function FPCTPageOne() {
  var {
    errors,
    touched,
    values,
    values: {
      isPlanningRetirementGoal,
      isTransitioningWealthGoal,
      isSavingForMajorPurchaseGoal,
      isBuildWealthGoal,
      isSavingForEducationExpensesGoal,
      isFamilyFinanciallySecureGoal
    },
    setFieldValue
  } = (0, _formik.useFormikContext)();
  console.log('Pg 1 values: ', values);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h4", null, " Establish goals"), /*#__PURE__*/_react.default.createElement("p", null, " Select the goals that matter most to you."), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.PlanningRetirementGoalCheckBox, {
    isPlanningRetirementGoal: isPlanningRetirementGoal,
    setFieldValue: setFieldValue
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.TransitionWealthGoalCheckBox, {
    isTransitioningWealthGoal: isTransitioningWealthGoal,
    setFieldValue: setFieldValue
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.SaveForMajorPurchaseGoalCheckBox, {
    isSavingForMajorPurchaseGoal: isSavingForMajorPurchaseGoal,
    setFieldValue: setFieldValue
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.BuildWealthMaxInvestmentsCheckBox, {
    isBuildWealthGoal: isBuildWealthGoal,
    setFieldValue: setFieldValue
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.SaveForEducationalExpensesGoalCheckBox, {
    isSavingForEducationExpensesGoal: isSavingForEducationExpensesGoal,
    setFieldValue: setFieldValue
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.EnsureFamilyFinanciallySecureGoalCheckBox, {
    isFamilyFinanciallySecureGoal: isFamilyFinanciallySecureGoal,
    setFieldValue: setFieldValue
  })))));
}